export type HelpCenterMigrationState =
	| 'FAILED'
	| 'IN_PROGRESS'
	| 'MIGRATED'
	| 'NOT_STARTED'
	| 'PUBLISHED'
	| '%future added value'
	| null;

export interface HelpCenterMigration {
	migratedHubAri: string | null;
	state: HelpCenterMigrationState;
}

export type MigrationManagementAction = 'none' | 'resume' | 'retry' | 'review' | 'update';

export interface MigrationManagementState {
	action: MigrationManagementAction;
	migratedHubAri: string | null;
	shouldShowLegacyCard: boolean;
	shouldWarnBeforeLegacyEdit: boolean;
}

const legacyManagementState = (
	action: MigrationManagementAction,
	migratedHubAri: string | null = null,
): MigrationManagementState => ({
	action,
	migratedHubAri,
	shouldShowLegacyCard: true,
	shouldWarnBeforeLegacyEdit: false,
});

export const resolveMigrationManagementState = ({
	migratedHubAri,
	state,
}: HelpCenterMigration): MigrationManagementState => {
	switch (state) {
		case null:
		case 'NOT_STARTED':
			return legacyManagementState('update');
		case 'IN_PROGRESS':
			return legacyManagementState('resume');
		case 'FAILED':
			return legacyManagementState('retry');
		case 'MIGRATED':
			return migratedHubAri
				? {
						action: 'review',
						migratedHubAri,
						shouldShowLegacyCard: true,
						shouldWarnBeforeLegacyEdit: true,
					}
				: legacyManagementState('none');
		case 'PUBLISHED':
			return {
				action: 'none',
				migratedHubAri: null,
				shouldShowLegacyCard: false,
				shouldWarnBeforeLegacyEdit: false,
			};
		case '%future added value':
		default:
			return legacyManagementState('none');
	}
};
